module.exports = __webpack_public_path__ + "img/side invisible zipper length.a145117c.png";